export const production = import.meta.env.MODE === 'production'

if (production) {
    import('core-js/stable')
    import('regenerator-runtime/runtime')
}
